import React, {useEffect, useState} from 'react';
import {useParams} from 'react-router-dom';
import {useNavigate} from "react-router-dom";
import {
    Box,
    Flex,
    Grid,
    GridItem,
    Text,
    Heading,
    Avatar,
    Badge,
    Button,
    Progress,
    SimpleGrid,
    Stat,
    Icon,
    HStack,
    VStack,
    Table,
    Card,
    FormatNumber, StatUpIndicator, StatDownIndicator, Spinner, Popover, Portal
} from '@chakra-ui/react';
import {useColorModeValue} from "../ui/color-mode"
import {
    FiDroplet,
    FiSun,
    FiCloudRain,
    FiThermometer,
    // FiCalendar,
    FiDollarSign,
    FiTrendingUp,
    FiTrendingDown,
    FiMapPin,
    FiCreditCard,
    FiAlertCircle,
    FiCheckCircle,
    FiAward,
    FiPieChart,
    FiBarChart2,
    FiLayers, FiCamera, FiInfo
} from 'react-icons/fi';
import {FaLeaf, FaTree, FaTractor, FaWater, FaSeedling} from 'react-icons/fa';
import {
    GiFruitBowl,
    GiCorn,
    GiFarmTractor,
    GiPlantWatering,
    GiLemon,
    GiOrange,
    GiWheat,
    GiPlantSeed, GiGrain, GiField
} from 'react-icons/gi';
import {LineChart, BarChart, PieChart, LineChart2} from '../Charts';
import MapWithDraw from "../SatelliteImageryData/MapWithDraw";
import FarmerInformationE from "../EnglishComponents/FarmerInformationE";
import FarmPhotosCardE from "../EnglishComponents/FarmPhotosCardE";
import WeatherInformationE from "../EnglishComponents/WeatherInformationE";
import DemoFarmPhotosCard from "./DemoFarmPhotosCard";

const baseUrl = process.env.REACT_APP_API_URL;
const baseUrlWs = process.env.REACT_APP_API_URL_WS;


const DemoFarmerDashboard = () => {
    const formatDateToSpanishMonthYear = (dateString) => {
        const date = new Date(dateString);
        let month = date.toLocaleString("en-US", {month: "long"});
        month = month.charAt(0).toUpperCase() + month.slice(1); // Capitalize first letter
        const year = date.getFullYear();
        return `${month}`;
    }


    const handlePolygonCreated = (newPolygon) => {
        console.log('New Polygon Created:', newPolygon);
    };

    const cardBg = useColorModeValue('white', 'white');
    // const infoColor = useColorModeValue('blue.500', 'blue.500');
    const [open, setOpen] = useState(false);
    const navigate = useNavigate();

    const [applicant, setApplicant] = useState(null);
    const [application, setApplication] = useState(null);
    const [isLoadingApplication, setIsLoadingApplication] = useState(null);
    const [applicantApplications, setApplicantApplications] = useState(null);
    const [weather, setWeather] = useState(null);
    const [water, setWater] = useState(null);
    const [crop, setCrop] = useState(null);
    const [isLoadingCrop, setIsLoadingCrop] = useState(true);
    const [isLoadingWater, setIsLoadingWater] = useState(true);
    const [isLoadingApplicant, setIsLoadingApplicant] = useState(true);
    const [isLoadingWeather, setIsLoadingWeather] = useState(true);
    const [weatherAnalysis, setWeatherAnalysis] = useState(null);
    const [isLoadingWeatherAnalysis, setIsLoadingWeatherAnalysis] = useState(true);
    const token = localStorage.getItem("token");

    const {applicant_id} = useParams();

    const cultivoOptions = [
        {label: "Alfalfa", value: "alfalfa"},
        {label: "Almond", value: "almendra"},
        {label: "Apple", value: "manzana"},
        {label: "Asparagus", value: "esparrago"},
        {label: "Avocado", value: "aguacate"},
        {label: "Banana", value: "platano"},
        {label: "Bean (Dry)", value: "frijol"},
        {label: "Blueberry", value: "arandano"},
        {label: "Broccoli", value: "brocoli"},
        {label: "Cabbage", value: "repollo"},
        {label: "Carrot", value: "zanahoria"},
        {label: "Chayote", value: "chayote"},
        {label: "Chili Pepper", value: "chile"},
        {label: "Cilantro", value: "cilantro"},
        {label: "Coffee", value: "cafe"},
        {label: "Corn", value: "maiz"},
        {label: "Cranberry", value: "arandano_rojo"},
        {label: "Grape", value: "uva"},
        {label: "Lettuce", value: "lechuga"},
        {label: "Onion", value: "cebolla"},
        {label: "Orange", value: "orange"},
        {label: "Papaya", value: "papaya"},
        {label: "Pea", value: "chicharo"},
        {label: "Persian Lime", value: "limon_persa"},
        {label: "Pineapple", value: "pina"},
        {label: "Potato", value: "papa"},
        {label: "Pumpkin", value: "calabaza"},
        {label: "Raspberry", value: "frambuesa"},
        {label: "Rice", value: "arroz"},
        {label: "Squash", value: "calabacin"},
        {label: "Strawberry", value: "fresa"},
        {label: "Sugar Cane", value: "cana"},
        {label: "Taro", value: "malanga"},
        {label: "Tomato", value: "jitomate"},
        {label: "Watermelon", value: "sandia"},
        {label: "Wheat", value: "trigo"}
    ];


    // useEffect(() => {
    //     const fetchApplicant = async () => {
    //         setIsLoadingApplicant(true);
    //         try {
    //             // const response = await fetch(`${baseUrl}/applicant/dashboard/${applicant_id}/`, {
    //             //     headers: {
    //             //         "Content-Type": "application/json",
    //             //         Authorization: `Bearer ${token}`,
    //             //         app_origin: "caz",
    //             //     },
    //             // });
    //             const response = await fetch(`${baseUrl}/applicant/dashboard/demo/`, {
    //                 headers: {
    //                     "Content-Type": "application/json",
    //                     Authorization: `Bearer ${token}`,
    //                     app_origin: "caz",
    //                 },
    //             });
    //             const data = await response.json();
    //             setApplicant(data);
    //         } catch (error) {
    //             console.error("Error fetching applicant:", error);
    //         } finally {
    //             setIsLoadingApplicant(false);
    //         }
    //     };
    //
    //     const fetchApplicantApplicationIds = async () => {
    //         // setIsLoadingApplicant(true);
    //         try {
    //             const response = await fetch(`${baseUrl}/applicant/applications/${applicant_id}/ids`, {
    //                 headers: {
    //                     "Content-Type": "application/json",
    //                     Authorization: `Bearer ${token}`,
    //                     app_origin: "caz",
    //                 },
    //             });
    //             const data = await response.json();
    //             setApplicantApplications(data);
    //         } catch (error) {
    //             console.error("Error fetching applicant:", error);
    //         } finally {
    //             // setIsLoadingApplicant(false);
    //         }
    //     };
    //
    //     if (applicant_id) {
    //         fetchApplicant();
    //         fetchApplicantApplicationIds();
    //     }
    // }, [applicant_id]);
    //
    // useEffect(() => {
    //     const fetchApplication = async () => {
    //         if (!applicantApplications) return;
    //         setIsLoadingApplication(true);
    //         try {
    //             const application_id = applicantApplications[0];
    //             const response = await fetch(`${baseUrl}/application/demo/`, {
    //                 headers: {
    //                     "Content-Type": "application/json",
    //                     Authorization: `Bearer ${token}`,
    //                     app_origin: "caz",
    //                 },
    //             });
    //             const application_data = await response.json();
    //             setApplication(application_data);
    //             console.log(application_data);
    //         } catch (error) {
    //             console.error("Error fetching weather:", error);
    //         } finally {
    //             setIsLoadingApplication(false);
    //         }
    //     };
    //
    //     if (applicantApplications) {
    //         fetchApplication();
    //     }
    // }, [applicantApplications]);

    // useEffect(() => {
    //     const fetchDemoData = async () => {
    //         try {
    //             setIsLoadingApplicant(true);
    //             setIsLoadingApplication(true);
    //
    //             // Fetch demo applicant
    //             const applicantResponse = await fetch(
    //                 `${baseUrl}/applicant/dashboard/demo/`,
    //                 {
    //                     headers: {
    //                         "Content-Type": "application/json",
    //                         Authorization: `Bearer ${token}`,
    //                         app_origin: "caz",
    //                     },
    //                 }
    //             );
    //
    //             const applicantData = await applicantResponse.json();
    //             setApplicant(applicantData);
    //
    //             // Fetch demo application
    //             const applicationResponse = await fetch(
    //                 `${baseUrl}/application/demo/`,
    //                 {
    //                     headers: {
    //                         "Content-Type": "application/json",
    //                         Authorization: `Bearer ${token}`,
    //                         app_origin: "caz",
    //                     },
    //                 }
    //             );
    //
    //             const applicationData = await applicationResponse.json();
    //             setApplication(applicationData);
    //             console.log("Demo application:", applicationData);
    //
    //         } catch (error) {
    //             console.error("Error fetching demo data:", error);
    //         } finally {
    //             setIsLoadingApplicant(false);
    //             setIsLoadingApplication(false);
    //         }
    //     };
    //
    //     fetchDemoData();
    // }, []);

    useEffect(() => {
        const fetchDemoData = async () => {
            try {
                console.log("DEBUG: Starting Applicant/Application fetch...");
                setIsLoadingApplicant(true);
                setIsLoadingApplication(true);

                // Fetching in parallel for speed
                const [applicantRes, applicationRes] = await Promise.all([
                    fetch(`${baseUrl}/applicant/dashboard/demo/`, {
                        headers: {
                            "Content-Type": "application/json",
                            Authorization: `Bearer ${token}`,
                            app_origin: "caz"
                        },
                    }),
                    fetch(`${baseUrl}/application/demo/`, {
                        headers: {
                            "Content-Type": "application/json",
                            Authorization: `Bearer ${token}`,
                            app_origin: "caz"
                        },
                    })
                ]);

                const applicantData = await applicantRes.json();
                const applicationData = await applicationRes.json();

                console.log("DEBUG: Received Applicant Data:", applicantData);
                console.log("DEBUG: Received Application Data:", applicationData);

                setApplicant(applicantData);
                setApplication(applicationData);

            } catch (error) {
                console.error("DEBUG ERROR: Initial fetch failed:", error);
            } finally {
                setIsLoadingApplicant(false);
                setIsLoadingApplication(false);
            }
        };

        fetchDemoData();
    }, []);

    // useEffect(() => {
    //     const fetchApplicantWeather = async () => {
    //         if (!applicant) return;
    //         setIsLoadingWeather(true);
    //         try {
    //             const response = await fetch(`${baseUrl}/applicant/dashboard/weather_e/demo/`, {
    //                 headers: {
    //                     "Content-Type": "application/json",
    //                     Authorization: `Bearer ${token}`,
    //                     app_origin: "caz",
    //                 },
    //             });
    //             const weather_data = await response.json();
    //             setWeather(weather_data);
    //             console.log(weather);
    //         } catch (error) {
    //             console.error("Error fetching weather:", error);
    //         } finally {
    //             setIsLoadingWeather(false);
    //         }
    //     };
    //
    //     fetchApplicantWeather();
    // }, [applicant]);

    useEffect(() => {
        if (!applicant) return;

        // --- SUB-FUNCTION: WEATHER ---
        const fetchWeather = async () => {
            setIsLoadingWeather(true);
            try {
                console.log("DEBUG: Fetching Weather for applicant...");
                const response = await fetch(`${baseUrl}/applicant/dashboard/weather_e/demo/`, {
                    headers: {"Content-Type": "application/json", Authorization: `Bearer ${token}`, app_origin: "caz"},
                });
                const weatherData = await response.json();
                console.log("DEBUG: Received Weather Data:", weatherData);
                setWeather(weatherData);
            } catch (err) {
                console.error("DEBUG ERROR: Weather fetch failed:", err);
            } finally {
                setIsLoadingWeather(false);
            }
        };

        // --- SUB-FUNCTION: CROP ANALYSIS ---
        const fetchCropAnalysis = async () => {
            setIsLoadingCrop(true);
            try {
                console.log("DEBUG: Sending Crop Analysis request for:", applicant.meta?.crop_type);
                const formData = new FormData();
                // Note: If weather isn't ready yet, this might send null/empty.
                // If backend needs weather for crop analysis, move this to the weather useEffect.
                formData.append("weather", JSON.stringify(weather || {}));
                formData.append("location", applicant.meta?.location || "");
                formData.append("crop_type", applicant.meta?.crop_type || "");
                formData.append("harvest_start", applicant.meta?.harvest_start || "");
                formData.append("harvest_end", applicant.meta?.harvest_end || "");
                formData.append("planting_date", applicant.meta?.planting_date || "");

                const response = await fetch(`${baseUrl}/applicant/dashboard/crop_e/analysis/demo/`, {
                    method: "POST",
                    headers: {Authorization: `Bearer ${token}`, app_origin: "caz"},
                    body: formData,
                });
                const cropData = await response.json();
                console.log("DEBUG: Received Crop Analysis:", cropData);
                setCrop(cropData);
            } catch (err) {
                console.error("DEBUG ERROR: Crop Analysis failed:", err);
            } finally {
                setIsLoadingCrop(false);
            }
        };

        // Trigger both in parallel
        fetchWeather();
        fetchCropAnalysis();

    }, [applicant]);

    // useEffect(() => {
    //     const fetchApplicantWater = async () => {
    //         if (!applicant) return;
    //         setIsLoadingWater(true);
    //         try {
    //             const response = await fetch(`${baseUrl}/applicant/dashboard/water_e/${applicant_id}/`, {
    //                 headers: {
    //                     "Content-Type": "application/json",
    //                     Authorization: `Bearer ${token}`,
    //                     app_origin: "caz",
    //                 },
    //             });
    //             const water_data = await response.json();
    //             setWater(water_data);
    //             console.log(water_data);
    //         } catch (error) {
    //             console.error("Error fetching water:", error);
    //         } finally {
    //             setIsLoadingWater(false);
    //         }
    //     };
    //
    //     fetchApplicantWater();
    // }, [applicant]);

    // useEffect(() => {
    //     const fetchApplicantCrop = async () => {
    //         if (!applicant) return;
    //         setIsLoadingCrop(true);
    //         try {
    //             const formData = new FormData();
    //             formData.append("weather", JSON.stringify(weather)); // stringify because it's an object
    //             formData.append("location", applicant.meta?.location || "");
    //             formData.append("crop_type", applicant.meta?.crop_type || "");
    //             formData.append("harvest_start", applicant.meta?.harvest_start || "");
    //             formData.append("harvest_end", applicant.meta?.harvest_end || "");
    //             formData.append("planting_date", applicant.meta?.planting_date || "");
    //             const response = await fetch(`${baseUrl}/applicant/dashboard/crop_e/analysis/demo/`, {
    //                 method: "POST",
    //                 headers: {
    //                     Authorization: `Bearer ${token}`,
    //                     app_origin: "caz",
    //                 },
    //                 body: formData,
    //             });
    //             const crop_data = await response.json();
    //             setCrop(crop_data);
    //             console.log(crop_data);
    //         } catch (error) {
    //             console.error("Error fetching crop:", error);
    //         } finally {
    //             setIsLoadingCrop(false);
    //         }
    //     };
    //
    //     fetchApplicantCrop();
    // }, [applicant]);

    // useEffect(() => {
    //     const fetchApplicantWeatherAnalysis = async () => {
    //         if (!weather) return;
    //         setIsLoadingWeatherAnalysis(true);
    //         console.log("analyzing weather");
    //
    //         try {
    //             const formData = new FormData();
    //             formData.append("weather", JSON.stringify(weather)); // stringify because it's an object
    //             formData.append("location", applicant.meta?.location || "");
    //             formData.append("crop_type", applicant.meta?.crop_type || "");
    //
    //             const response = await fetch(`${baseUrl}/applicant/dashboard/weather_e/analysis/demo/`, {
    //                 method: "POST",
    //                 headers: {
    //                     Authorization: `Bearer ${token}`,
    //                     app_origin: "caz",
    //                 },
    //                 body: formData,
    //             });
    //
    //             const weather_data_analysis = await response.json();
    //             setWeatherAnalysis(weather_data_analysis);
    //             console.log(weatherAnalysis);
    //         } catch (error) {
    //             console.error("Error fetching weather analysis:", error);
    //         } finally {
    //             setIsLoadingWeatherAnalysis(false);
    //         }
    //     };
    //
    //     fetchApplicantWeatherAnalysis();
    // }, [applicant, weather]);

    // useEffect(() => {
    //     if (!weather) return;
    //
    //     let ws;
    //     let fullText = "";
    //
    //     const fetchApplicantWeatherAnalysis = async () => {
    //         setIsLoadingWeatherAnalysis(true);
    //         console.log("analyzing weather (streaming)");
    //
    //         try {
    //             const wsUrl = `${baseUrlWs}/applicant/dashboard/weather_e/ws/demo/`;
    //             ws = new WebSocket(wsUrl);
    //
    //             ws.onopen = () => {
    //                 ws.send(JSON.stringify({
    //                     weather,
    //                     location: applicant?.meta?.location || "",
    //                     crop_type: applicant?.meta?.crop_type || "",
    //                 }));
    //             };
    //
    //             ws.onmessage = (event) => {
    //                 const data = JSON.parse(event.data);
    //
    //                 if (data.type === "chunk") {
    //                     fullText += data.chunk;
    //                     setWeatherAnalysis(fullText.trim());
    //                 }
    //
    //                 if (data.status === "complete" || data.status === "error") {
    //                     setIsLoadingWeatherAnalysis(false);
    //                     ws.close();
    //                 }
    //             };
    //
    //             ws.onerror = (error) => {
    //                 console.error("Weather WS error:", error);
    //                 setIsLoadingWeatherAnalysis(false);
    //             };
    //
    //         } catch (error) {
    //             console.error("Error fetching weather analysis:", error);
    //             setIsLoadingWeatherAnalysis(false);
    //         }
    //     };
    //
    //     fetchApplicantWeatherAnalysis();
    //
    //     // 🔥 Cleanup on unmount or dependency change
    //     return () => {
    //         if (ws && ws.readyState === WebSocket.OPEN) {
    //             ws.close();
    //         }
    //     };
    //
    // }, [applicant, weather]);
    //
    //
    // useEffect(() => {
    //     if (weatherAnalysis) {
    //         console.log("New Weather Analysis:", weatherAnalysis);
    //     }
    // }, [weatherAnalysis]);

    // useEffect(() => {
    //     if (!weather || !applicant) return;
    //
    //     let ws;
    //     let accumulatedText = "";
    //     let isCancelled = false; // prevents React strict mode double-run issues
    //
    //     const connectWebSocket = () => {
    //         setIsLoadingWeatherAnalysis(true);
    //         setWeatherAnalysis("");
    //
    //         const wsUrl = `${baseUrlWs}/applicant/dashboard/weather_e/ws/demo/`;
    //         console.log("Connecting to:", wsUrl);
    //
    //         ws = new WebSocket(wsUrl);
    //
    //         ws.onopen = () => {
    //             console.log("WS OPENED");
    //
    //             ws.send(JSON.stringify({
    //                 weather,
    //                 location: applicant?.meta?.location || "",
    //                 crop_type: applicant?.meta?.crop_type || "",
    //             }));
    //         };
    //
    //         ws.onmessage = (event) => {
    //             const data = JSON.parse(event.data);
    //
    //             if (data.type === "chunk") {
    //                 accumulatedText += data.chunk;
    //
    //                 // Avoid updating state if component unmounted
    //                 if (!isCancelled) {
    //                     setWeatherAnalysis(accumulatedText);
    //                 }
    //             }
    //
    //             if (data.status === "complete") {
    //                 console.log("WS COMPLETE");
    //                 if (!isCancelled) {
    //                     setIsLoadingWeatherAnalysis(false);
    //                 }
    //                 ws.close();
    //             }
    //
    //             if (data.status === "error") {
    //                 console.error("Server error:", data.detail);
    //                 if (!isCancelled) {
    //                     setIsLoadingWeatherAnalysis(false);
    //                 }
    //                 ws.close();
    //             }
    //         };
    //
    //         ws.onerror = (err) => {
    //             console.error("WS ERROR:", err);
    //             if (!isCancelled) {
    //                 setIsLoadingWeatherAnalysis(false);
    //             }
    //             ws.close();
    //         };
    //
    //         ws.onclose = (event) => {
    //             console.log("WS CLOSED:", event.code, event.reason);
    //         };
    //     };
    //
    //     connectWebSocket();
    //
    //     return () => {
    //         console.log("Cleanup triggered");
    //         isCancelled = true;
    //
    //         if (ws && ws.readyState === WebSocket.OPEN) {
    //             ws.close();
    //         }
    //     };
    //
    // }, [weather, applicant]);

    useEffect(() => {
        if (!weather || !applicant) return;

        let ws;
        let accumulatedText = "";
        let isCancelled = false;

        const connectWebSocket = () => {
            setIsLoadingWeatherAnalysis(true);
            setWeatherAnalysis("");

            const wsUrl = `${baseUrlWs}/applicant/dashboard/weather_e/ws/demo/`;
            const payload = {
                weather,
                location: applicant?.meta?.location || "",
                crop_type: applicant?.meta?.crop_type || "",
            };

            console.log(`DEBUG: WS Connecting to ${wsUrl}`);
            console.log("DEBUG: WS Outgoing Payload:", payload);

            ws = new WebSocket(wsUrl);

            ws.onopen = () => {
                console.log("DEBUG: WS Connection Opened");
                ws.send(JSON.stringify(payload));
            };

            ws.onmessage = (event) => {
                const data = JSON.parse(event.data);
                console.log("DEBUG: WS Message Received:", data);

                if (data.type === "chunk") {
                    accumulatedText += data.chunk;
                    if (!isCancelled) setWeatherAnalysis(accumulatedText);
                }

                if (data.status === "complete") {
                    console.log("DEBUG: WS Stream Complete");
                    if (!isCancelled) setIsLoadingWeatherAnalysis(false);
                    ws.close();
                }
            };

            ws.onerror = (err) => {
                console.error("DEBUG ERROR: WS Socket Error:", err);
                if (!isCancelled) setIsLoadingWeatherAnalysis(false);
            };

            ws.onclose = (e) => console.log("DEBUG: WS Closed", e.code, e.reason);
        };

        connectWebSocket();

        return () => {
            isCancelled = true;
            if (ws?.readyState === WebSocket.OPEN) ws.close();
        };
    }, [weather]);

    return (
        <Box p={{base: 4, md: 6}} bgGradient="to-r" gradientFrom="gray.100" gradientTo="gray.100">
            {/* Encabezado */}
            {/*{applicant_id}*/}
            <Flex
                flexDirection={{base: "column", md: "row"}}
                justifyContent="space-between"
                alignItems={{base: "flex-start", md: "center"}}
                gap={4}
                mb={8}>
                <VStack align="flex-start">
                    <Heading as="h1" size="xl">Credit Risk Dashboard</Heading>
                    <Text color="gray.500">Detailed analysis for decision-making</Text>

                </VStack>
                <HStack>
                    <Button variant="outline"
                            colorPalette="blue"
                            bg={"white"}
                            loading={isLoadingApplicant}
                            onClick={() => navigate(`/financial-analysis-demo`)}
                    >
                        Financial Information
                    </Button>
                    {/*<Button variant="outline"*/}
                    {/*        colorPalette="green"*/}
                    {/*        bg={"white"}*/}
                    {/*        loading={isLoadingApplicant}*/}
                    {/*        onClick={() => navigate(`/credit-memo/demo`)}*/}
                    {/*>*/}
                    {/*    Credit Memo*/}
                    {/*</Button>*/}
                </HStack>


            </Flex>

            {/* Sección de información del agricultor */}
            <Grid templateColumns="repeat(12, 1fr)" gap={6} mb={8}>
                {/* Tarjeta de perfil */}
                <GridItem colSpan={{base: 12, md: 6, lg: 4}}>
                    <FarmerInformationE cardBg={cardBg} applicant={applicant} loading={isLoadingApplicant}
                                        application={application} isLoadingAppplication={isLoadingApplication}/>
                </GridItem>


                {/* Información del cultivo */}
                <GridItem colSpan={{base: 12, md: 6, lg: 4}}>
                    <Card.Root bg={cardBg} borderRadius="xl" h="full">
                        <Card.Header>
                            <Heading size="md">
                                <Icon as={GiFruitBowl} mr={2} color="green.500"/> Crop Information
                            </Heading>
                        </Card.Header>
                        <Card.Body>
                            {applicant && (
                                <VStack spacing={4} align="stretch">
                                    <HStack>
                                        <Icon as={GiWheat} color="green.600" boxSize={5}/>
                                        <Box>
                                            <Text fontSize="sm" color="gray.500">Crop Name</Text>
                                            {/*<Text fontWeight="bold">{capitalize(applicant?.meta.crop_type)}</Text>*/}
                                            <Text fontWeight="bold">
                                                {
                                                    cultivoOptions.find(option => option.value === applicant?.meta?.crop_type)?.label
                                                    || applicant?.meta?.crop_type  // fallback in case no match is found
                                                }
                                            </Text>

                                        </Box>
                                    </HStack>

                                    <HStack>
                                        <Icon as={GiPlantSeed} color="teal.500" boxSize={5}/>
                                        <Box>
                                            <Text fontSize="sm" color="gray.500">Planted on</Text>
                                            <Text
                                                fontWeight="bold">{formatDateToSpanishMonthYear(applicant?.meta.planting_date)}</Text>
                                        </Box>
                                    </HStack>

                                    <HStack>
                                        <Icon as={GiGrain} color="orange.500" boxSize={5}/>
                                        <Box>
                                            <Text fontSize="sm" color="gray.500">Harvest Start Date</Text>
                                            <Text
                                                fontWeight="bold">{formatDateToSpanishMonthYear(applicant?.meta.harvest_start)}</Text>
                                        </Box>
                                    </HStack>

                                    <HStack>
                                        <Icon as={GiField} color="blue.500" boxSize={5}/>
                                        <Box>
                                            <Text fontSize="sm" color="gray.500">Total Acres</Text>
                                            <Text fontWeight="bold">{applicant?.meta.farm_acreage} ac</Text>
                                        </Box>
                                    </HStack>

                                    <HStack>
                                        <Icon as={GiFarmTractor} color="blue.500" boxSize={5}/>
                                        <Box>
                                            <Text fontSize="sm" color="gray.500">Cultivated Acres</Text>
                                            <Text fontWeight="bold">{applicant?.meta.production_acreage} ac</Text>
                                        </Box>
                                    </HStack>

                                    <HStack>
                                        <Icon as={FiBarChart2} color="purple.500" boxSize={5}/>
                                        <Box>
                                            <Text fontSize="sm" color="gray.500">Expected Yield</Text>
                                            <Text
                                                fontWeight="bold">{applicant?.meta?.average_yield_per_acre} ton/ha</Text>
                                        </Box>
                                    </HStack>

                                    <Popover.Root open={open} onOpenChange={(e) => setOpen(e.open)}>
                                        <Popover.Trigger asChild>
                                            <Button
                                                size="sm"
                                                variant="outline"
                                                leftIcon={<FiInfo/>}
                                                onClick={() => setOpen(!open)}
                                                loading={isLoadingCrop}
                                            >
                                                Crop Analysis
                                            </Button>
                                        </Popover.Trigger>
                                        <Portal>
                                            <Popover.Positioner>
                                                <Popover.Content w="sm">
                                                    <Popover.Arrow/>
                                                    <Popover.Body>
                                                        {crop ? (
                                                            <Text whiteSpace="pre-wrap">{crop}</Text>
                                                        ) : (
                                                            <Text color="gray.500" fontSize="sm">There is no analysis
                                                                available.</Text>
                                                        )}
                                                    </Popover.Body>
                                                </Popover.Content>
                                            </Popover.Positioner>
                                        </Portal>
                                    </Popover.Root>
                                </VStack>
                            )}
                        </Card.Body>
                    </Card.Root>
                </GridItem>

                {/* Información climática */}
                <GridItem colSpan={{base: 12, md: 12, lg: 4}}>
                    <WeatherInformationE weather={weather} cardBg={cardBg} loading={isLoadingWeather}
                                         weatherAnalysis={weatherAnalysis}
                                         loadingAnalysis={isLoadingWeatherAnalysis}/>
                </GridItem>
            </Grid>

            {/* Segunda fila de información */}
            <Grid templateColumns="repeat(12, 1fr)" gap={6} mb={8}>
                {/* Mapa satelital */}
                <GridItem colSpan={{base: 12, md: 6}}>
                    <Card.Root bg={cardBg} borderRadius="xl">
                        <Card.Header>
                            <Heading size="md">
                                <Icon as={FiMapPin} mr={2} color="red.500"/> Satellite Imagery
                                <Button variant="outline" ml={8}
                                        onClick={() => navigate(`/satellite-imagery-demo`)}>
                                    More Information
                                </Button>
                            </Heading>
                        </Card.Header>
                        <Card.Body>
                            <Box h="400px" bg="gray.100" borderRadius="lg" overflow="hidden" position="relative">
                                <Box zIndex={0}>
                                    <MapWithDraw geoJson={applicant?.meta?.polygon_data}
                                                 onPolygonCreated={handlePolygonCreated}
                                                 zIndex={0}/>
                                </Box>
                            </Box>
                        </Card.Body>
                    </Card.Root>
                </GridItem>

                <GridItem colSpan={{base: 12, md: 6}}>
                    {applicant && (
                        <DemoFarmPhotosCard
                            // photos={applicant.meta?.farm_photos || []}
                            // token={token}
                            // baseUrl={baseUrl}
                        />)}
                </GridItem>
            </Grid>

            <Grid templateColumns="repeat(12, 1fr)" gap={6} mb={8}>

                <GridItem colSpan={{base: 12, lg: 6}}>
                    <Card.Root bg={cardBg} borderRadius="xl">
                        <Card.Header>
                            <Heading size="md">
                                <Icon as={FiCreditCard} mr={2} color="blue.500"/> Loan Requests
                            </Heading>
                        </Card.Header>
                        <Card.Body>
                            <Table.Root>
                                {/*<Table.Body variant="simple">*/}
                                <Table.Header>
                                    <Table.Row>
                                        <Table.ColumnHeader>Amount</Table.ColumnHeader>
                                        <Table.ColumnHeader>Purpose</Table.ColumnHeader>
                                        <Table.ColumnHeader>Status</Table.ColumnHeader>
                                    </Table.Row>
                                </Table.Header>
                                <Table.Body>
                                    {applicant && (
                                        <Table.Row>
                                            <Table.Cell>${applicant.meta.loan_requested}</Table.Cell>
                                            <Table.Cell>{applicant.meta.loan_use}</Table.Cell>
                                            <Table.Cell>
                                                <Badge colorPalette="green">
                                                    <Icon as={FiCheckCircle} mr={1}/> Pre-approved
                                                </Badge>
                                            </Table.Cell>
                                        </Table.Row>
                                    )}
                                </Table.Body>
                            </Table.Root>
                        </Card.Body>
                    </Card.Root>
                </GridItem>
            </Grid>

            {applicant?.meta?.invoices_result?.monthlySummary && (
                <Grid templateColumns="repeat(12, 1fr)" gap={6} mb={8}>
                    {/* Monthly Financial Performance */}
                    <GridItem colSpan={6}>
                        <Card.Root bg={cardBg} borderRadius="xl">
                            <Card.Header>
                                <Heading size="md">
                                    <Icon as={FiTrendingUp} mr={2} color="green.500"/> Monthly Expected Yield
                                </Heading>
                            </Card.Header>
                            <Card.Body>
                                {/*{applicant?.meta?.invoices_result?.monthlySummary && (*/}
                                <Box height="300px">
                                    {/*<LineChart*/}
                                    {/*    data={applicant.meta.invoices_result.monthlySummary}*/}
                                    {/*    xKey="yearMonth"*/}
                                    {/*    yKey="NetIncome"*/}
                                    {/*    color="#3182CE"*/}
                                    {/*    unit="MXN"*/}
                                    {/*/>*/}
                                    <LineChart2
                                        data={applicant.meta.invoices_result.monthlySummary}
                                        xKey="yearMonth"
                                        yKeys={["Revenue", "Expense", "NetIncome"]}
                                        colors={["#38A169", "#E53E3E", "#3182CE"]}
                                        unit="MXN"
                                    />
                                </Box>
                                {/*)}*/}
                            </Card.Body>
                        </Card.Root>
                    </GridItem>


                    {/* Annual Financial Summary */}
                    <GridItem colSpan={6}>
                        <Card.Root bg={cardBg} borderRadius="xl">
                            <Card.Header>
                                <Heading size="md">
                                    <Icon as={FiBarChart2} mr={2} color="blue.500"/> Annual Financial Summary
                                </Heading>
                            </Card.Header>
                            <Card.Body>
                                {applicant?.meta?.invoices_result?.annualSummary && (
                                    <Box height="300px">
                                        <BarChart
                                            data={applicant.meta.invoices_result.annualSummary.map(year => ({
                                                name: year.year.toString(),
                                                value: year.NetIncome
                                            }))}
                                            colors={["#38A169", "#3182CE", "#805AD5"]}
                                        />
                                    </Box>
                                )}
                            </Card.Body>
                        </Card.Root>
                    </GridItem>

                    {/* Expense Breakdown */}
                    <GridItem colSpan={4}>
                        <Card.Root bg={cardBg} borderRadius="xl">
                            <Card.Header>
                                <Heading size="md">
                                    <Icon as={FiPieChart} mr={2} color="purple.500"/> Last Year Expenses
                                </Heading>
                            </Card.Header>
                            <Card.Body>
                                {applicant?.meta?.invoices_result?.annualExpenseBreakdown && (
                                    <Box>
                                        <Box height="400px">
                                            <PieChart
                                                data={Object.entries(
                                                    applicant.meta.invoices_result.annualExpenseBreakdown
                                                        .slice(-1)[0] // Get the most recent year
                                                )
                                                    .filter(([key]) => !['year'].includes(key))
                                                    .map(([name, value]) => ({
                                                        name,
                                                        value
                                                    }))}
                                                colors={["#38B2AC", "#DD6B20", "#E53E3E", "#D69E2E", "#805AD5", "#3182CE", "#38A169"]}
                                            />
                                        </Box>
                                    </Box>
                                )}
                            </Card.Body>
                        </Card.Root>
                    </GridItem>
                </Grid>)}
        </Box>
    );
};

export default DemoFarmerDashboard;